import React, { useMemo, useState, useEffect } from "react";
import "../themes/appearance.css";

import { AppearanceContext } from "./AppearanceContext";

import {
  applyAppearance,
  loadAppearance,
  saveAppearance,
} from "../utils";

const AppearanceProvider = ({ children }) => {
  const savedAppearance = useMemo(
    () => loadAppearance(),
    []
  );

  const [theme, setTheme] = useState(
    savedAppearance?.theme ?? "project-felt"
  );

  const [colorScheme, setColorScheme] = useState(
    savedAppearance?.colorScheme ?? "light"
  );

  const [contrastMode, setContrastMode] = useState(
    savedAppearance?.contrastMode ?? "glass"
  );

  const value = useMemo(
    () => ({
      theme,
      colorScheme,
      contrastMode,

      setTheme,
      setColorScheme,
      setContrastMode,
    }),
    [
      theme,
      colorScheme,
      contrastMode,
    ]
  );

  useEffect(() => {
    applyAppearance({
      theme,
      colorScheme,
      contrastMode,
    });
  }, [
    theme,
    colorScheme,
    contrastMode,
  ]);

  useEffect(() => {
    saveAppearance({
      theme,
      colorScheme,
      contrastMode,
    });
  }, [
    theme,
    colorScheme,
    contrastMode,
  ]);
  return (
    <AppearanceContext.Provider value={value}>
        {children}
    </AppearanceContext.Provider>
  );
};

export default AppearanceProvider;